import ChartSolidgauge from './DSCReviews/ChartSolidgauge'
import './DSCReviews.scss'
// import ProcessDanhMuc from './DSCReviews/ProcessDanhMuc'
import BoxItemStock from './DSCReviews/BoxItemStock'
import { useSelector } from 'react-redux';

export default function DSCReviews() {
  const AStore = useSelector((state) => state?.AStore);
  const textDscRanking = AStore?.Overview?.dscRanking ? Object.values(AStore?.Overview?.dscRanking)?.[0] : ''
  
  return (
    <>
      <div className="EJVSwHlaEo">
        <div className="SVjGTkbIPg">DSC đánh giá</div>
        <div className="FelLlrDmvp">
          <div className="yZYcQzeWvc">
            <div className="NpRCGgVEuC">{textDscRanking}</div>
          </div>
          <div className="CuCETdpShk">
            <ChartSolidgauge />
          </div>
        </div>
        <BoxItemStock />  
        {/* <ProcessDanhMuc /> */}
      </div>
    </>
  )
}
